import { ENTITY_TYPES } from '@sales-center/common'
import { useEditLocation } from '@user/components/Location/MatchCreateNew/hooks/useEditLocation'
import { useTabData } from '@user/components/Location/MatchCreateNew/hooks/useTabData'
import { useCheckPermissions } from '@user/store/authorization/permissions/useCheckPermissions'
import { useMemo } from 'react'

type Params = {
  entityId: number
  entityType: ENTITY_TYPES
}

export function useData(params: Params) {
  const { entityId, entityType } = params

  const { anyInvalid, serviceLocations, billToLocations } = useTabData()

  const [_, formDispatch, onCloseForm] = useEditLocation()

  const [canUpdateLeads, canUpdateOpps] = useCheckPermissions(
    'leads_update',
    'opportunities_update',
  )

  const canUpdateEntity = useMemo(
    () => (entityType == 'LEAD' ? canUpdateLeads : canUpdateOpps),
    [entityType, canUpdateLeads, canUpdateOpps],
  )

  return {
    anyInvalid,
    serviceLocations,
    billToLocations,
    entityBranchId: billToLocations[0]?.branchId?.toString() ?? '',
    entityType,
    entityId,
    formDispatch,
    canUpdateEntity,
    onClose: onCloseForm,
    variant: 'form',
  }
}
